<div class="card px-0 pt-4 pb-2">
  <div class="flex flex-column mx-4 mb-3">
    <div *ngIf="!loadingSharedResource" class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
      <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
        <span *ngIf="sharedResource.resourceType === 'DEVICE'">{{'model.device' | transloco}}</span>
        <span *ngIf="sharedResource.resourceType === 'ASSET'">{{'model.asset' | transloco}}</span>
        {{sharedResource.name}} ({{sharedResource.organizationOwnerUuid | organizationsResolver}})
      </p>
      <div class="flex-order-0 sm:flex-order-1">
        <button
          (click)="showSharedDialog()"
          [label]="'misc.sharedPopUp.share' | transloco"
          pButton
          pRipple
          class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
          icon="pi pi-share-alt"
        ></button>
      </div>
    </div>
    <div *ngIf="loadingSharedResource" class="mt-2 mb-3">
      <p-skeleton width="100%" height="4rem"></p-skeleton>
    </div>
    <div *ngIf="!loadingSharedResource">
      <p *ngIf="sharedResource.catalogInfo && sharedResource.catalogInfo['description']"><b>{{'attribute.description' | transloco}}: </b>{{sharedResource.catalogInfo['description']}}</p>
      <p *ngIf="!sharedResource.catalogInfo || !sharedResource.catalogInfo['description']" class="font-italic">{{'empty.description' | transloco}}</p>
    </div>
  </div>
</div>
<div style="margin-top: 15px;">
  <div class="card p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
    <div class="p-datatable-header">
      <div class="flex flex-column sm:flex-row justify-content-between">
        <div class="flex flex-column md:flex-row">
          <button
            [label]="'common.stopSharing' | transloco"
            [disabled]="selected.length == 0"
            (click)="confirmAndStopSharingSelected()"
            pButton
            pRipple
            class="p-button-danger mb-2 sm:mb-0"
            icon="pi pi-times"
          ></button>
        </div>
        <div class="flex flex-column md:flex-row justify-content-end">
          <button
            [label]="'common.filters' | transloco"
            (click)="filtersVisible = !filtersVisible"
            pButton
            class="p-button-secondary filtersFilled"
            icon="pi pi-filter"
          ></button>
        </div>
      </div>
    </div>
    <p-table
      #table
      [(first)]="first"
      [(rows)]="rows"
      [value]="sharedWithEmails"
      [totalRecords]="totalSharedEmails"
      [(selection)]="selected"
      [responsive]="true"
      [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
      [paginator]="true"
      [rowsPerPageOptions]="[10,25,50]"
      (onFilter)="onFilter($event)"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="selection-column-width"></th>
          <th pSortableColumn="entityType">
            {{'attribute.entityType' | transloco}}<p-sortIcon field="entityType"></p-sortIcon></th>
          <th pSortableColumn="name">
            {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="email">
            {{'attribute.email' | transloco}}<p-sortIcon field="email"></p-sortIcon></th>
          <th pSortableColumn="sharedByUser">
            {{'attribute.sharedBy' | transloco}}<p-sortIcon field="sharedByUser"></p-sortIcon></th>
          <th pSortableColumn="sharedDate">
            {{'attribute.sharedDate' | transloco}}<p-sortIcon field="sharedDate"></p-sortIcon></th>
          <th class="w-10rem">
            {{'common.actions' | transloco}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-shareData>
        <tr *ngIf="!loadingSharedResource">
          <td>
            <span class="p-column-title bold">{{'common.select' | transloco}}</span>
            <p-tableCheckbox [value]="shareData"></p-tableCheckbox>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.entityType' | transloco}}</span>
            <div *ngIf="shareData.entityType === 'TENANT'" class="flex align-items-center">
              <div class="entity-circle p-2 flex align-items-center mr-2">
                <i class="pi pi-briefcase"></i>
              </div>
              <span>{{'model.tenant' | transloco}}</span>
            </div>
            <div *ngIf="shareData.entityType === 'ORGANIZATION'" class="flex align-items-center">
              <div class="entity-circle p-2 flex align-items-center mr-2">
                <i class="pi pi-sitemap"></i>
              </div>
              <span>{{'model.organization' | transloco}}</span>
            </div>
            <div *ngIf="shareData.entityType === 'USER'" class="flex align-items-center">
              <div class="entity-circle p-2 flex align-items-center mr-2">
                <i class="pi pi-user"></i>
              </div>
              <span>{{'model.user' | transloco}}</span>
            </div>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
            {{shareData.name}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.email' | transloco}}</span>
            <p class="text-right md:text-left">{{shareData.email}}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.sharedBy' | transloco}}</span>
            <p class="text-right md:text-left">{{shareData.sharedByUser}}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.sharedDate' | transloco}}</span>
            <p class="text-right md:text-left">{{shareData.sharedDate | customDate}}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
            <div class="flex justify-content-end">
              <button
                (click)="confirmAndStopSharing(shareData)"
                class="p-button-rounded btn-danger-light"
                pButton
                pRipple
                icon="pi pi-times"
              ></button>
            </div>
          </td>
        </tr>
        <tr *ngIf="loadingSharedResource">
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex">
          <div class="my-auto">
            <div *ngIf="totalSharedEmails == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div *ngIf="totalSharedEmails > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalSharedEmails ? totalSharedEmails : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalSharedEmails}}
              {{(totalSharedEmails > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.name"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            appAutoFocus
            pInputText
            class="w-full"
            id="name"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="email">{{'attribute.email' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.email"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            class="w-full"
            id="email"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="email">{{'attribute.sharedBy' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.sharedBy"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            class="w-full"
            id="sharedBy"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'attribute.entityType' | transloco}}</label>
        </div>
        <div class="col-12 flex flex-column">
          <div>
            <button
              [ngClass]="currentFilters.entityType == null ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
              (click)="setSelectedEntityType(null)"
              pRipple
            >
              <i class="pi pi-circle-off"></i>
              {{'common.all' | transloco}}
            </button>
          </div>
          <div>
            <button
              [ngClass]="currentFilters.entityType === 'TENANT' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
              (click)="setSelectedEntityType('TENANT')"
              pRipple
            >
              <i class="pi pi-briefcase"></i>
              {{'model.tenants' | transloco}}
            </button>
          </div>
          <div>
            <button
              [ngClass]="currentFilters.entityType === 'ORGANIZATION' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
              (click)="setSelectedEntityType('ORGANIZATION')"
              pRipple
            >
              <i class="pi pi-sitemap"></i>
              {{'model.organizations' | transloco}}
            </button>
          </div>
          <div>
            <button
              [ngClass]="currentFilters.entityType === 'USER' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
              (click)="setSelectedEntityType('USER')"
              pRipple
            >
              <i class="pi pi-user"></i>
              {{'model.users' | transloco}}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.name ||
            currentFilters.entityType ||
            currentFilters.email ||
            currentFilters.sharedBy
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>

<app-share-entity-dialog *ngIf="showDialog"
                         [sharedResources]="sharedResources"
                         (sharedResourceChange)="sharedResourceSuccess()"
                         [(dialogVisible)]="showDialog">
</app-share-entity-dialog>
